import { useParams } from "react-router-dom";
import MetaHead from "../../../Common/Metahead";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { affiliateCommissionDetail } from "../../../../stores/actions/affiliate.actions.types";
import { BiLoaderAlt } from "react-icons/bi";

const CommissionDetailPage = ({ affiliateCommissionDetail, loading }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [commission, setCommission] = useState(null);

  useEffect(() => {
    if (id) {
      affiliateCommissionDetail({
        id,
        callback: (data) => {
          if (data?.success) {
            setCommission(data?.data?.commissions);
          }
        },
      });
    }
  }, [id, affiliateCommissionDetail]);

  if (loading) {
    return (
      <div className='flex items-center justify-center min-h-screen'>
        <BiLoaderAlt className='animate-spin text-5xl text-primary dark:text-white' />
      </div>
    );
  }

  if (!commission) {
    return (
      <div className='flex items-center justify-center min-h-screen text-gray-500 dark:text-gray-400'>
        No commission details available.
      </div>
    );
  }

  return (
    <div>
      <MetaHead title='Commission Details' />
      <div className='p-4 sm:p-6 lg:p-8'>
        <div className='relative bg-white dark:bg-boxdark rounded-xl shadow-sm p-6 sm:p-8 max-w-4xl mx-auto'>
          <h2 className='text-2xl font-semibold text-dark dark:text-white mb-6'>
            Commission Details
          </h2>

          <div className='grid grid-cols-1 md:grid-cols-2 gap-4 text-sm'>
            <Field label='Referral Code' value={commission?.referralCode} />
            <Field
              label='Sales Amount'
              value={`$${commission?.salesAmount?.toFixed(2)}`}
            />
            <Field
              label='Commission Amount'
              value={`$${commission?.commissionAmount?.toFixed(2)}`}
            />
            <Field
              label='Status'
              value={commission?.status}
              highlight={"red"}
            />
            <Field
              label='Created At'
              value={new Date(commission?.createdAt).toLocaleString()}
            />
          </div>
          {commission?.orderId && (
            <div className='mt-6 pt-4'>
              <h3 className='text-lg font-medium text-dark dark:text-white mb-4'>
                Order Info
              </h3>
              <div className='overflow-x-auto'>
                <table className='min-w-full divide-y divide-gray-200 dark:divide-gray-700'>
                  <thead className='bg-gray-100 dark:bg-gray-800'>
                    <tr>
                      <th className='px-4 py-2 text-left text-xs font-semibold text-gray-600 dark:text-gray-300'>
                        Order ID
                      </th>
                      <th className='px-4 py-2 text-left text-xs font-semibold text-gray-600 dark:text-gray-300'>
                        Email
                      </th>
                      <th className='px-4 py-2 text-left text-xs font-semibold text-gray-600 dark:text-gray-300'>
                        Status
                      </th>
                      <th className='px-4 py-2 text-left text-xs font-semibold text-gray-600 dark:text-gray-300'>
                        Total Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody className='bg-white dark:bg-boxdark divide-y divide-gray-100 dark:divide-gray-800'>
                    <tr>
                      <td className='px-4 py-2 text-sm text-dark dark:text-white'>
                        {commission?.orderId?.orderId || "—"}
                      </td>
                      <td className='px-4 py-2 text-sm text-dark dark:text-white'>
                        {commission?.orderId?.email || "—"}
                      </td>
                      <td className='px-4 py-2 text-sm text-dark dark:text-white'>
                        {commission?.orderId?.status || "—"}
                      </td>
                      <td className='px-4 py-2 text-sm text-dark dark:text-white'>
                        $ {commission?.orderId?.data?.netCost || "—"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
const Field = ({ label, value, highlight }) => (
  <div>
    <p className='text-sm text-gray-500 dark:text-gray-400 mb-1'>{label}</p>
    <p
      className={`text-lg font-medium break-all ${
        highlight === "green"
          ? "text-green-600"
          : highlight === "red"
          ? "text-red-600"
          : "text-dark dark:text-white"
      }`}
    >
      {value || "—"}
    </p>
  </div>
);
const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, { affiliateCommissionDetail })(
  CommissionDetailPage
);
